import { PHONEME_DATA_LIST, TROUBLE_PHONEME_BY_LANGUAGE } from "./constants";

export const refreshHighlight = (selectedLanguageCode: any, mySoundPhonemes: any) => {
  if (selectedLanguageCode == "0") {
    const oidArray = [];
    for (const phoneme of mySoundPhonemes) {
      for (const phonemeData of PHONEME_DATA_LIST) {
        if (phonemeData.phoneme === phoneme) {
          oidArray.push(phonemeData.Id);
        }
      }
    }
    return oidArray;
  } else {
    const oidArray = TROUBLE_PHONEME_BY_LANGUAGE[selectedLanguageCode];
    return oidArray;
  }
};